import { useEffect, useState } from 'react';
import { patchItems } from '@/components/Patches/PatchSearchItems';
import { searchContext } from '../../../../context/Context';
import { formatStrMatch } from '../helpers';
import { SearchContext } from '../../../../types';
import { DATASETS } from '@/components/Constants';

const Row = ({ label, value }: { label: string; value?: string | number }) =>
  value != null && String(value).trim() !== '' ? (
    <span className="react-dropdown__suggestion-row">
      <span className="react-dropdown__suggestion-label">{label}:</span> {String(value)}
    </span>
  ) : null;

const SectionItem = ({ item }) => {
  // patch item until BE is upgraded
  item = patchItems(item);

  const [isChecked, setIsChecked] = useState(false);
  const { searchItems, setSearchItems } = searchContext() as unknown as SearchContext;
  const strMatch = formatStrMatch(item);

  const handleClick = (event, item) => {
    setSearchItems!(prevItems =>
      prevItems.some(prevItem => prevItem.id === item.id)
        ? prevItems.filter(prevItem => prevItem.id !== item.id)
        : [...prevItems, item],
    );
  };

  useEffect(() => {
    setIsChecked(searchItems!.some(prevItem => prevItem.id === item.id));
  }, [searchItems]);

  const content =
    item.dataset === DATASETS.DISEASES ? (
      <>
        <Row label="Name" value={item.name} />
        <Row label="CUI" value={item.diseaseUMLSCUI ?? item.id} />
        <Row label="N. genes" value={item.numGenesAssociatedToDisease_ALL} />
        <Row label="N. snps" value={item.numVariantsAssociatedToDisease_ALL} />
        <Row label="Match" value={strMatch.replace(/^Match: /, '')} />
      </>
    ) : item.dataset === DATASETS.GENES ? (
      <>
        <Row label="Symbol" value={item.symbol} />
        <Row label="Description" value={item.description} />
        <Row label="Entrez ID" value={item.ncbiID} />
        <Row label="N. diseases" value={item.numDiseasesAssociatedToGene_ALL} />
        <Row label="N. snps" value={item.numVariantsAssociatedToGene_ALL} />
        <Row label="Match" value={strMatch.replace(/^Match: /, '')} />
      </>
    ) : item.dataset === DATASETS.VARIANTS ? (
      <>
        <Row label="SNPdb id" value={item.strID} />
        <Row label="Gene Symbol" value={item.geneSymbol} />
        <Row label="N. diseases" value={item.numDiseasesAssociatedToVariant_ALL} />
        <Row label="Match" value={strMatch.replace(/^Match: /, '')} />
      </>
    ) : item.dataset === DATASETS.CHEMICALS ? (
      <>
        <Row label="Name" value={item.chemPrefName} />
        <Row label="ID" value={item.chemID} />
        <Row label="N. PMIDs" value={item.chemNumPublications} />
        <Row label="Match" value={strMatch.replace(/^Match: /, '')} />
      </>
    ) : (
      <>
        <Row label="Match" value={strMatch.replace(/^Match: /, '')} />
      </>
    );

  return (
    <li className="react-dropdown__suggestion" onClick={event => handleClick(event, item)}>
      <input type="checkbox" checked={isChecked} readOnly />
      <span className="checkmark" />
      <div className="react-dropdown__suggestion-content">{content}</div>
    </li>
  );
};

export default SectionItem;
